import RegularEvent from './regularEvent';
import Content, { Type } from '../types/enums/content';
import { IFastEventRequest } from '../types/interfaces/event';
import { ISeason } from '../types/interfaces/vod';

const SECONDS_PER_MINUTE = 60;


class FastEvent extends RegularEvent {
  season: ISeason;
  seasonEpisodes: number | undefined;
  seasonId: string | undefined;

  constructor(request: IFastEventRequest) {
    let type = Content.SHOW;
    switch (request.type) {
      case Type.SEASON:
        type = Content.SEASON;
        break;
      case Type.SERIES:
        type = Content.SERIES;
        break;
    }

    super(request, type);
    this.duration =
      (Math.round(request.duration / SECONDS_PER_MINUTE)) ||
      (request.length !== undefined ? request.length : 0);
    this.season = {};
    this.seasonEpisodes = request.seasonEpisodes;
    this.seasonId = request.seasonId;
  }
}

export default FastEvent;
